import { forwardRef } from "react";
import { ReactComponent as Logo } from "../../assets/logo.svg";
import styles from "./styles.module.scss";

export const MembershipBadge = forwardRef<HTMLDivElement, { grade: string }>(
  ({ grade }, ref) => {
    const currentYear = new Date().getFullYear();
    const getGrade = () => {
      switch (grade) {
        case "Fellow":
          return "Fellow";
        case "Full":
          return "Full Member";
        case "Associate":
          return "Associate";
        case "Student":
          return "Student";
        case "Corporate":
          return "Corporate";
        default:
          return "";
      }
    };
    return (
      <div className={styles.badgeBody}>
        <div className={styles.badgeContent} ref={ref}>
          <Logo className={styles.logo} />
          <p className={styles.memberType}>{getGrade()}</p>
          <div className={styles.line}></div>
          <div className={styles.memberYear}>{currentYear}</div>
        </div>
      </div>
    );
  },
);
